import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config/config";
import axios from "axios";
import { IoShieldCheckmarkOutline, IoShieldCheckmark } from "react-icons/io5";

const AccountHolderDetails = ({ onSubmit, onIsHumanChange }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [gender, setGender] = useState("Woman");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [role, setRole] = useState("User Admin");
  const [sliderValue, setSliderValue] = useState(0);
  const [isHuman, setIsHuman] = useState(false);
  const [verifyMessage, setVerifyMessage] = useState(
    "Swipe to verify if human"
  );
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [dob, setDob] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const baseURL = config.API_BASE_URL;

  const navigate = useNavigate();

  const handleSliderChange = (event) => {
    const currentValue = parseInt(event.target.value);
    setSliderValue(currentValue);

    const adminUser = {
      firstName,
      lastName,
      email,
      password,
      mobileNumber,
      assignedRole: role,
      gender,
      roles: [
        {
          id: "6524833b8a14e2388ebcc5c6",
          roleName: "ADMIN",
        },
      ],
      dateOfBirth: dob ? new Date(dob).toISOString().split("T")[0] : null,
      isEmailVerified: false,
      isPhoneNumberVerified: false,
    };

    if (currentValue >= 80 && !hasSubmitted) {
      console.log("Admin User Object: ", adminUser);

      if (isEmptyField()) {
        setSliderValue(0);
        setErrorMessage(
          "Please ensure all form fields are correctly filled out."
        );
        setIsHuman(false);
        event.target.disabled = true;

        if (onIsHumanChange && typeof onIsHumanChange === "function") {
          onIsHumanChange(false);
        }

        return;
      }

      if (!validateForm()) {
        setSliderValue(0);
        setIsHuman(false);
        event.target.disabled = true;

        if (onIsHumanChange && typeof onIsHumanChange === "function") {
          onIsHumanChange(false);
        }

        return;
      }

      setIsHuman(true);
      setHasSubmitted(true);

      if (onIsHumanChange && typeof onIsHumanChange === "function") {
        onIsHumanChange(true);
      }

      setVerifyMessage("Click next to continue");
    } else if (currentValue < 80) {
      setIsHuman(false);

      if (onIsHumanChange && typeof onIsHumanChange === "function") {
        onIsHumanChange(false);
      }
    }
  };

  const enableSlider = () => {
    if (document.querySelector(".human-slider")) {
      document.querySelector(".human-slider").disabled = false;
    }
  };

  const isEmptyField = () => {
    return (
      !firstName || !lastName || !mobileNumber || !email || !password || !dob
    );
  };

  const validateForm = () => {
    if (isEmptyField()) {
      setErrorMessage(
        "Please ensure all form fields are correctly filled out."
      );
      return false;
    }
    if (!firstName || !lastName) {
      setErrorMessage("First name and Last name are required!");
      return false;
    }

    const emailRegex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    if (!email.match(emailRegex)) {
      setErrorMessage("Please provide a valid email!");
      return false;
    }

    if (
      !mobileNumber ||
      mobileNumber.length !== 10 ||
      !/^[\d]+$/.test(mobileNumber)
    ) {
      setErrorMessage("Please provide a valid phone number with 10 digits!");
      return false;
    }

    if (!password) {
      setErrorMessage("Please enter a password.");
      return false;
    }
    const passwordCriteria = {
      length: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasDigit: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*()_+[\]{};':"\\|,.<>?/-]/.test(password),
    };
    const strength = Object.values(passwordCriteria).filter(Boolean).length;
    if (strength < 4) {
      setErrorMessage(
        "Your password is too weak! Valid password must have at least 8 characters with uppercase/lowercase letters, one digit, special characters"
      );

      return false;
    }

    return true;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = {
        firstName,
        lastName,
        gender,
        mobileNumber,
        email,
        password,
        assignedRole: role,
        dateOfBirth: dob,
        isEmailVerified: false,
        isPhoneNumberVerified: false,
        roles: [
          {
            id: "6524833b8a14e2388ebcc5c6",
            roleName: "ADMIN",
          },
        ],
      };
      try {
        const response = await axios.post(
          `${baseURL}/v1/administration`,
          formData
        );
        if (response.data) {
          console.log("Admin User registered successfully.");
        } else {
          setErrorMessage("An error occurred while registering the user.");
        }
      } catch (error) {
        setErrorMessage("An error occurred while registering the user.");
      }
    }
  };

  const clearErrorMessage = () => {
    setErrorMessage("");
  };

  const handleCheckboxChange = (e) => {
    if (isEmptyField()) {
      e.preventDefault();
      setIsChecked(false);
      setErrorMessage(
        "Please ensure all form fields are correctly filled out."
      );
      return;
    }

    if (!validateForm()) {
      e.preventDefault();
      setIsChecked(false);
    } else {
      setIsChecked(true);
      const mockEvent = { preventDefault: () => {} };
      handleFormSubmit(mockEvent);
    }
  };

  function checkPasswordStrength(inputElement) {
    const password = inputElement.value;
    const passwordStrengthElement = document.getElementById("passwordStrength");

    const criteria = {
      length: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasDigit: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*()_+[\]{};':"\\|,.<>?/-]/.test(password),
    };

    const strength =
      criteria.length +
      criteria.hasUpperCase +
      criteria.hasLowerCase +
      criteria.hasDigit +
      criteria.hasSpecialChar;

    passwordStrengthElement.innerHTML = `Password strength: <span class="${getPasswordStrengthClass(
      strength
    )}">${getPasswordStrengthText(strength)}</span>`;
  }

  function getPasswordStrengthText(strength) {
    if (strength === 0) return "Very Weak";
    if (strength === 1) return "Weak";
    if (strength === 2) return "Moderate";
    if (strength === 3) return "Strong";
    if (strength >= 4) return "Very Strong";
  }

  function getPasswordStrengthClass(strength) {
    if (strength === 0) return "very-weak";
    if (strength === 1) return "weak";
    if (strength === 2) return "moderate";
    if (strength === 3) return "strong";
    if (strength >= 4) return "very-strong";
  }

  const handleDobChange = (part, value) => {
    let newDob = { day, month, year };

    if (part === "day") newDob.day = value;
    if (part === "month") newDob.month = value;
    if (part === "year") newDob.year = value;

    setDay(newDob.day);
    setMonth(newDob.month);
    setYear(newDob.year);

    if (newDob.day && newDob.month && newDob.year) {
      setDob(
        `${newDob.year}-${newDob.month.padStart(2, "0")}-${newDob.day.padStart(
          2,
          "0"
        )}`
      );
    }
  };

  return (
    <div className="account-holder-details-container">
      <div className="logo-container">
        <Link to="/">
          <img src="/images/osh_logo.png" alt="Company Logo" width="350" />
        </Link>
      </div>
      <div className="separator"></div>
      <h1>Add account holder's details</h1>
      <form onSubmit={handleFormSubmit}>
        <div className="form-row">
          <div className="form-column">
            <label className="input-label" htmlFor="firstname">
              First name
            </label>
            <input
              className="form-input"
              type="text"
              id="firstname"
              required
              onChange={(e) => {
                setFirstName(e.target.value);
                enableSlider();
              }}
              onFocus={clearErrorMessage}
            />
          </div>

          <div className="form-column">
            <label className="input-label" htmlFor="lastname">
              Last name
            </label>
            <input
              className="form-input"
              type="text"
              id="lastname"
              required
              onChange={(e) => {
                setLastName(e.target.value);
                enableSlider();
              }}
              onFocus={clearErrorMessage}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-column">
            <label className="input-label" htmlFor="email">
              Email
            </label>
            <input
              className="form-input"
              type="email"
              id="email"
              required
              onChange={(e) => {
                setEmail(e.target.value);
                enableSlider();
              }}
              onFocus={clearErrorMessage}
            />
          </div>

          <div className="form-column">
            <label className="input-label" htmlFor="password">
              Password
            </label>
            <input
              className="form-input"
              type="password"
              id="password"
              required
              onInput={(e) => checkPasswordStrength(e.target)}
              onChange={(e) => {
                setPassword(e.target.value);
                enableSlider();
              }}
              onFocus={clearErrorMessage}
            />
            <div className="password-strength" id="passwordStrength"></div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-column-dob">
            <div>
              <label className="input-label" htmlFor="mobilenumber">
                Mobile Number
              </label>
              <input
                className="form-input"
                type="text"
                id="mobilenumber"
                required
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  enableSlider();
                }}
                onFocus={clearErrorMessage}
              />
            </div>

            <div>
              <label className="input-label" htmlFor="referral">
                Admin Role
              </label>
              <select
                className="form-input"
                id="referral"
                required
                onChange={(e) => {
                  setRole(e.target.value);
                  setIsChecked(false);
                  enableSlider();
                }}
              >
                <option value="User Admin">User Admin</option>
                <option value="Support Admin">Support Admin</option>
              </select>
            </div>

            <div>
              <label className="input-label" htmlFor="gender">
                Gender
              </label>
              <select
                className="form-input"
                id="gender"
                required
                onChange={(e) => {
                  setGender(e.target.value);
                  setIsChecked(false);
                  enableSlider();
                }}
              >
                <option value="Woman">Woman</option>
                <option value="Man">Man</option>
                <option value="Transgender Woman">Transgender Woman</option>
                <option value="Transgender Man">Transgender Man</option>
                <option value="Non-binary">Non-binary</option>
                <option value="Genderqueer">Genderqueer</option>
                <option value="Agender">Agender (no gender identity)</option>
                <option value="No Preference">No Preference</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-column dob-container">
            <label className="input-label" htmlFor="dob-day">
              Date of Birth
            </label>
            <div className="dob-selects">
              <select
                className="form-input dob-input"
                id="dob-day"
                required
                onChange={(e) => handleDobChange("day", e.target.value)}
              >
                <option value="">Day</option>
                {[...Array(31)].map((_, index) => (
                  <option key={index + 1} value={index + 1}>
                    {index + 1}
                  </option>
                ))}
              </select>
              <select
                className="form-input dob-input"
                id="dob-month"
                required
                onChange={(e) => handleDobChange("month", e.target.value)}
              >
                <option value="">Month</option>
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((month, index) => (
                  <option key={index + 1} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
              <select
                className="form-input dob-input"
                id="dob-year"
                required
                onChange={(e) => handleDobChange("year", e.target.value)}
              >
                <option value="">Year</option>
                {[...Array(100)].map((_, index) => (
                  <option key={index + 1920} value={index + 1920}>
                    {index + 1920}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <div className="robot-checkbox-container">
          <div className="slider-container">
            {isHuman && (
              <h4 className="human-message">
                Human verified{" "}
                <IoShieldCheckmark className="human-verified-icon" />
              </h4>
            )}
            <h6 className="slider-header">{verifyMessage}</h6>

            <input
              className="human-slider"
              type="range"
              min="0"
              max="100"
              value={sliderValue}
              onChange={handleSliderChange}
            />
          </div>
        </div>
        <div className="back-next-navigation-buttons">
          <button className="multiform-back-button">Cancel</button>
          <button className="multiform-next-button">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default AccountHolderDetails;
